import React, { PropTypes } from 'react';
import { reduxForm, Field } from 'redux-form';
import { I18n } from 'react-redux-i18n';

//import FormInput from '../../common/components/FormInput';


const AdvancedSettingsForm = ({
  handleSubmit,
  // storeSettings,
  submitting,
  handleCancel,
  isEnglishIn

}) => {



  return (
    <div>
      <form onSubmit={handleSubmit}>

        <h5>{I18n.t('ADVANCED_SETTINGS_LABEL_HEADER_TITLE')}</h5>
        <p>{I18n.t('ADVANCED_SETTINGS_LABEL_HEADER_DESCRIPTION')}</p>
        <div className="row">
        
          <label htmlFor="example-text-input" className="col-lg-2 col-sm-2 col-form-label">{I18n.t('ADVANCED_SETTINGS_LABEL_HEADER_FIELD')}</label>
          <div className="col-lg-10 col-sm-10">

            <Field name="LabelTitleOrder" component="select">
            <option value="0">{I18n.t('ADVANCED_SETTINGS_LABEL_HEADER_LAT_N')}</option>
              <option value="1">{I18n.t('ADVANCED_SETTINGS_LABEL_HEADER_N_LAT')}</option>
              <option value="2">{I18n.t('ADVANCED_SETTINGS_LABEL_HEADER_IN_N_LAT')}</option>
            </Field>
          </div>
        </div>

        <h5>{I18n.t('ADVANCED_SETTINGS_LABEL_PLU_TITLE')}</h5>
        <p>{I18n.t('ADVANCED_SETTINGS_LABEL_PLU_DESCRIPTION')}</p>
        <div className="row">
          <label htmlFor="example-text-input" className="col-lg-2 col-sm-2 col-form-label">{I18n.t('ADVANCED_SETTINGS_LABEL_PLU_FIELD')}</label>
          <div className="col-lg-10 col-sm-10">
            <Field name="UsePLUCode" component="select">
              <option value="true">{I18n.t('YES')}</option>
              <option value="false">{I18n.t('NO')}</option>

            </Field>
          </div>
        </div>

{isEnglishIn && <div>
        <h5>{I18n.t('ADVANCED_SETTINGS_LABEL_METRIC_TITLE')}</h5>
        <p>{I18n.t('ADVANCED_SETTINGS_LABEL_METRIC_DESCRIPTION')}</p>
        <div className="row">
          <label htmlFor="example-text-input" className="col-lg-2 col-sm-2 col-form-label">{I18n.t('ADVANCED_SETTINGS_LABEL_METRIC_FIELD')}</label>
          <div className="col-lg-10 col-sm-10">
            <Field name="UseUSMetrics" component="select">
              <option value="false">{I18n.t('ADVANCED_SETTINGS_LABEL_METRIC_EU')}</option>
              <option value="true">{I18n.t('ADVANCED_SETTINGS_LABEL_METRIC_US')}</option>
            </Field>
          </div>
        </div>
        </div>
}

{isEnglishIn && false && <div>
        <h5>{I18n.t('ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_TITLE')}</h5>
        <p>{I18n.t('ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_DESCRIPTION')}</p>
        <div className="row">
          <label htmlFor="example-text-input" className="col-lg-2 col-sm-2 col-form-label">{I18n.t('ADVANCED_SETTINGS_LABEL_PAGE_FORMAT_FIELD')}</label>
          <div className="col-lg-10 col-sm-10">
            <Field name="IsPaperSizeLetter" component="select">
              <option value="false">A4</option>
              <option value="true">Letter</option>

            </Field>
          </div>
        </div>
        </div>

}


        <h5>{I18n.t('PRINTER_ADJUSTMENT')}</h5>
        <div className="row">
          <div className="col-sm-12">

            <div dangerouslySetInnerHTML={{ __html: I18n.t('ADJUSTMENT_INSTRUCTIONS') }} />
            <br />
          </div>
        </div>
        <div className="row">

          <label htmlFor="example-text-input" className="col-lg-2 col-sm-2 col-form-label">{I18n.t('B_HORIZONTAL')}</label>
          <div className="col-lg-10 col-sm-10">
            <Field name="pageOffset.PosX"
              component="input"
              type="number"
              className="form-control"
            />
          </div>
        </div>

        <div className="row">

          <label htmlFor="example-text-input" className="col-lg-2 col-sm-2 col-form-label">{I18n.t('A_VERTICAL')}</label>
          <div className="col-lg-10 col-sm-10">
            <Field name="pageOffset.PosY"
              component="input"
              type="number"
              className="form-control"
            />
          </div>
        </div>






        {/*                 <h5>{I18n.t('ADVANCED_SETTINGS_LABEL_PRINTER_CALIBRATION_TITLE')}</h5>
                <div className="row">
            <label htmlFor="example-text-input" className="col-lg-1 col-sm-2 col-form-label">{I18n.t('ADVANCED_SETTINGS_LABEL_PRINTER_CALIBRATION_TITLE')}</label>
            <div className="col-lg-11 col-sm-10">
              <Field  name="line2" 
                      component={FormInput} 
                      type="text" 
                      className="form-control"  
              />
            </div> 
          </div>*/}
        <div className="label-customize ">
          <div className="row no-gutters bottom-buttons">

            <div className="col-sm-12 text-right">
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>{I18n.t('CANCEL')}</button>
              <button type="submit" className="btn btn-primary" disabled={submitting}>{I18n.t('SAVE')}</button>
            </div>


          </div>


        </div>
      </form>
    </div>
  );
};

AdvancedSettingsForm.propTypes = {
  form: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  //  storeSettings: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,
  isEnglishIn: PropTypes.bool.isRequired,
};

export default reduxForm()(AdvancedSettingsForm);


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/AdvancedSettingsForm.js
 **/